import { ErpPartnerClientsAccumulation } from "src/entities/erpPartnerClientsAccumulation/ui/ErpPartnerClientsAccumulation";

export const ErpPartnerClientsAccumulationPage = () => {
  return <ErpPartnerClientsAccumulation />;
};
